import { render } from "./GetPlain.vue?vue&type=template&id=fecbc64a&scoped=true"
import script from "./GetPlain.vue?vue&type=script&lang=js"
export * from "./GetPlain.vue?vue&type=script&lang=js"

import "./GetPlain.vue?vue&type=style&index=0&id=fecbc64a&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fecbc64a"]])

export default __exports__